import { r } from './api-utils';

const api = {
  vehicle: {
    config: r('GET Vehicle/VehicleConfig')
  }
};
export default api;
